import { isValidGuid } from '../../utils/guid';
import { VCurrentRegistrationCodeLength } from '../../utils/constants';
export const isVNextRegistrationCode = (registrationCode) => {
    const isGuid = isValidGuid(registrationCode);
    return registrationCode.length !== VCurrentRegistrationCodeLength && !isGuid;
};
